import React, { useMemo } from 'react'
import partition from 'lodash/partition'

import { OfferType } from '@monorepo/interfaces'
import { OfferItem } from './OfferItem'
import { CartIcon } from './OfferItem/icons'

type PropsType = {
  items: Array<OfferType>
}

export const OffersList: React.FC<PropsType> = ({ items }) => {
  const [inStockOffers, onOrderOffers] = useMemo(
    () => partition(items, 'isStock'),
    [items]
  )

  return (
    <>
      <Header />
      <List items={inStockOffers} title="Товары в наличии" />
      <List items={onOrderOffers} title="Товары под заказ" />
    </>
  )
}

type ListProps = {
  title: React.ReactNode
  items: OfferType[]
}

const List: React.FC<ListProps> = ({ title, items }) => {
  return items.length > 0 ? (
    <>
      <div className="w-100 font-italic bg-light text-dark text-center">
        {title}
      </div>
      {items.map((item) => (
        <OfferItem key={item.itemKey} item={item} />
      ))}
    </>
  ) : null
}

const Header: React.FC<Object> = () => (
  <div className="d-flex d-xl-none align-items-center align-self-stretch justify-content-center border-0 flex-shrink-0 m-0 py-2 bg-light">
    <div className="text-uppercase product-card__prices align-items-center border-0">
      <small>Наличие</small>
    </div>
    <div className="text-uppercase product-card__prices align-items-center border-0">
      <small>Срок|Склад</small>
    </div>
    <div className="text-uppercase product-card__prices align-items-center border-0">
      <small>Цена</small>
    </div>
    <div style={{ padding: '0 8px', margin: '0 16px' }}>
      <CartIcon />
    </div>
  </div>
)
